/* Color en la tarjeta (oct-2026). En las tarjetas con muestras de color, al elegir un color el botón
   «Elegir opciones» pasa a «Añadir al carrito» y añade ESE color directamente (un clic menos: antes había
   que abrir el panel y volver a elegir). Actualiza el icono y el carrito lateral con las funciones del tema. */
(function () {
  'use strict';
  if (window.bwCardColor) return;
  window.bwCardColor = true;

  function cardOf(el) { return el.closest('li, .card, product-card'); }

  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('.card__swatches .js-option') || !input.dataset.variantId) return;
    var card = cardOf(input);
    var btn = card && card.querySelector('.js-quick-add');
    if (!btn) return;
    card.dataset.bwVariant = input.dataset.variantId;
    if (!btn.dataset.bwLabel) btn.dataset.bwLabel = btn.innerHTML;
    var name = (card.querySelector('label[for="' + input.id + '"]') || {}).title || input.value;
    btn.textContent = 'Añadir al carrito · ' + name;
  });

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('.js-quick-add');
    if (!btn) return;
    var card = cardOf(btn);
    if (!card || !card.dataset.bwVariant) return; // sin color elegido: comportamiento normal del tema
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    var drawerSection = drawer && drawer.closest('.shopify-section');
    if (drawerSection) sections.push(drawerSection.id.replace('shopify-section-', ''));

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(card.dataset.bwVariant), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se ha podido añadir.');
        return data;
      });
    }).then(function (data) {
      var PF = customElements.get('product-form');
      if (PF && PF.updateCartIcon && data.sections) PF.updateCartIcon(data);
      if (drawer && drawer.renderContents && data.sections) drawer.renderContents({ sections: data.sections }, true);
    }).catch(function (e) {
      btn.textContent = 'Sin stock en ese color';
      btn.title = e.message;
    }).finally(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
    });
  }, true);
})();
